"use client";
import { j as e } from "./index.es52.js";
import { forwardRef as m, useMemo as c } from "react";
import { makeUniqueId as h } from "./index.es184.js";
m(
  ({
    label: d,
    isChecked: o,
    onChange: r,
    isDefaultChecked: a,
    isDisabled: t,
    inputId: i,
    ...l
  }, n) => {
    const s = c(() => h(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-radio-button", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...l,
          ref: n,
          type: "radio",
          id: i || s,
          onChange: r,
          defaultChecked: a,
          disabled: t,
          checked: o
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: i || s, children: d })
    ] });
  }
);
//# sourceMappingURL=index.es54.js.map
